import type { ExchangeRateResponse } from '@contracts/exchangeRate/ExchangeRateResponse';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';

export const ExchangeRateClient = {
  list: async (): Promise<ExchangeRateResponse[]> => {
    const response =
      await AuthenticatedClient.get<ExchangeRateResponse[]>('/exchange-rate');

    return response.data;
  },
  setRate: async (data: {
    cadToUsd: number;
    usdToCad: number;
  }): Promise<void> => {
    await AuthenticatedClient.post('/exchange-rate/set-rate', data);
  },
};
